import i18n from '@/plugins/i18n';
import { getRandomUniqueId } from '@/utils/helper-function';

export const endpointFormMutations = {
  REPLACE_DATA: 'REPLACE_DATA',
  MODIFY_FIELDS: 'MODIFY_FIELDS',
};

export const basicInfoDefaultData = {
  url: '',
  urlAlias: '',
  endpointType: 'HTTP',
};

const rowId = getRandomUniqueId();

export const authDetailsDefaultData = {
  authType: 'NONE',
  tokenId: '',
  headerPrefix: '',
  tokenName: '',
};

export const reqDetailsDefaultData = {
  checkType: 'GET',
  expectedStatus: 200,
  headers: { [rowId]: { rowId, key: '', value: '', isSelected: true } },
  responseRegex: '',
  postData: '',
};

export const additionalOptnsDefaultData = {
  interval: 600,
  timeout: 20,
  permalinkUrl: '',
  ssl: false,
};

// constants of endpoint form type
export const ADD = 'ADD';
export const DUPLICATE = 'DUPLICATE';
export const EDIT = 'EDIT';

export const authTypes = [
  { name: i18n.global.t('sm.none-label'), value: 'NONE' },
  { name: i18n.global.t('sm.oauth-2-0'), value: 'OAUTH2' },
];
